import axios from 'axios';

import {
  requestInterceptHandler,
  responseInterceptErrorHandler,
} from '@/components/shared/utility/axios';

export const CONTENT_HUB_GALLERY_PER_PAGE = 10;
export const CONTENT_HUB_GRID_PER_PAGE = 5;
export const OFFER_PER_PAGE = 6;
export const NEWS_PER_PAGE = 9;
export const RELATED_NEWS_PER_PAGE = 6;

const clientAxios = axios.create({
  baseURL: `${process.env.HOST}/api/contentstack`,
  method: 'post',
});

clientAxios.interceptors.request.use(requestInterceptHandler);
clientAxios.interceptors.response.use(
  (response) => response,
  responseInterceptErrorHandler
);

export default clientAxios;
